const isInt = (text) => {
    let parsedValue = parseInt(text);
    return !(isNaN(parsedValue) || !isFinite(parsedValue));
};
const isFloat = (text) => {
    let parsedValue = parseFloat(text);
    return !(isNaN(parsedValue) || !isFinite(parsedValue));
};
const toInt = (text, dfltInt) => {
    return isInt(text) ? parseInt(text) : dfltInt;
};
const isString = (x) => {
    return typeof x === 'string';
};
const toString = (val) => {
    if (isString(val)) {
        return val;
    }
    return isDefinedAndNotNull(val) ? val + "" : null;
};
const isStringNotBlank = (str) => {
    if (isString(str)) {
        return str.trim().length;
    }
    return false;
};
const isBlankNullOrUndefined = (str) => {
    if (isString(str)) {
        return str.trim().length === 0;
    }
    return isNull(str) || isUndefined(str);
};
const isNull = (x) => {
    return x === null;
};
const isNotNull = (x) => {
    return !isNull(x);
};
const isUndefined = (x) => {
    return typeof x === 'undefined';
};
const isNotUndefined = (x) => {
    return !isUndefined(x);
};
const isDefinedAndNotNull = (x) => {
    return isNotUndefined(x) && isNotNull(x);
};
const isArrayNullOrEmpty = (arr) => {
    return !Array.isArray(arr) || arr.length <= 0;
};
const isArrayNotNullOrEmpty = (arr) => {
    return Array.isArray(arr) && arr.length > 0;
};
const isDeepEqual = (a, b) => {
    if (a === b) {
        return true;
    }
    if (!isDefinedAndNotNull(a) || !isDefinedAndNotNull(b) || typeof a !== typeof b) {
        return false;
    }
    if (Array.isArray(a) || Array.isArray(b)) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
            return false;
        }
        return a.every((value, index) => isDeepEqual(value, b[index]));
    }
    if (typeof a === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        return aKeys.every(key => isDeepEqual(a[key], b[key]));
    }
    return false;
};
export { isInt, isFloat, toInt, isString, isStringNotBlank, isBlankNullOrUndefined, toString, isNull, isNotNull, isUndefined, isNotUndefined, isDefinedAndNotNull, isArrayNullOrEmpty, isArrayNotNullOrEmpty, isDeepEqual };
